import "./permissionPage.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { Container, Stack, Typography, IconButton, Snackbar } from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useWeb3React } from "@web3-react/core";
import { RootState } from "../../store/rootReducer";
import { useWeb3AuthContext } from "../../contexts/web3Auth";
import IconError from "../../assets/images/icons/icon-error.png";
import { ContainButton, LinearText, getSearchParams } from "../../utils";


export const PermissionPage = () => {
    const navigate = useNavigate();
    const role = getSearchParams("role")!;
    const tokenAddress = getSearchParams("tokenAddress")!;
    const { data } = useSelector((state: RootState) => state.status)
    const { deactivate } = useWeb3React();
    const { logoutWeb3Auth } = useWeb3AuthContext();
    const [open, setOpen] = useState(false);
    const handleReload = async () => {
        navigate(`/?tokenAddress=${localStorage.getItem("tokenContractAddress")}`);
        localStorage.removeItem("_address_temp")
        localStorage.removeItem("address");
        localStorage.removeItem("_s");
        localStorage.setItem("walletConnected", "disconnect");
        logoutWeb3Auth();
        deactivate();
    };

    const handleClick = () => {
        setOpen(true);
        navigator.clipboard.writeText(localStorage.getItem("_address_temp") || '');
    };

    return (
        <>
            {role ?
                <Container maxWidth="md"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '80vh'
                    }}
                >
                    <Stack gap={4} display={'flex'} justifyContent={'center'} alignItems={'center'} textAlign={'center'}>
                        <img src={IconError} alt="IconError" width={100} height={100} />
                        <Typography fontSize={38} fontWeight={600}>
                            {role === "issuer" ? (
                                <>
                                    Sorry,
                                    <LinearText>Insufficient balance</LinearText>
                                </>
                            ) : role === "externalFactoryToken" ? (
                                <>

                                    Sorry, this token is not created by
                                    <LinearText>Six Token Manager Factory</LinearText>
                                </>
                            ) : role === "nonTokenCreator" ? (
                                <>

                                    Sorry, you are not the creator of <br />
                                    <LinearText>Six Token Manager Factory</LinearText>
                                </>
                            ) : role === "badAddressManageToken" ? (
                                <>
                                    <span style={{ whiteSpace: "nowrap" }}>
                                        Sorry, the address you entered is not a valid address
                                    </span>
                                </>
                            ) : role === "badAddressAddToken" ? (
                                <>
                                    <span style={{ whiteSpace: "nowrap" }}>
                                        Sorry, the address you entered is not a valid address
                                    </span>
                                </>
                            )

                                : (
                                    <>
                                        Sorry, you don’t have
                                        <LinearText>Permission</LinearText>
                                    </>
                                )}
                        </Typography>
                        {_.get(data, "message") ?
                            <Typography fontSize={28} fontWeight={400}>
                                {_.get(data, "message")}
                            </Typography> :
                            role === "controller" &&
                            <Typography fontSize={28} fontWeight={400}>
                                Copy your wallet address here {localStorage.getItem("_address_temp")} {
                                    <IconButton onClick={handleClick} color="primary">
                                        <ContentCopyIcon />
                                    </IconButton>
                                } and send it to the issuer
                                so the controller can update your role
                            </Typography>
                        }
                        {
                            role === "externalFactoryToken" &&
                            <Typography fontSize={28} fontWeight={400}>
                                Try to add the token to the factory               <Typography fontSize={20} fontWeight={400}>({tokenAddress})</Typography>
                            </Typography>

                        }
                        {
                            role === "externalFactoryToken" ? (
                                <ContainButton onClick={() => { navigate(`/tokenAction/add-exit-token?tokenAddress=${tokenAddress}`) }}>Add token</ContainButton>
                            ) : role === "nonTokenCreator" ? (
                                <ContainButton onClick={() => { navigate("/tokenAction") }}>Back</ContainButton>
                            ) : (role === "badAddressManageToken" || role === "badAddressAddToken") ? (
                                null
                            )
                                : (
                                    <ContainButton onClick={() => handleReload()}>Back</ContainButton>
                                )
                        }

                    </Stack>
                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: "right" }}
                        open={open}
                        autoHideDuration={4000}
                        onClose={() => setOpen(false)}
                        message={localStorage.getItem("_address_temp")}
                        key="topright"
                    />
                </Container> : <></>}
        </>
    );
};

export default PermissionPage;
